var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content w"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.newsDetail.catName))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.newsDetail.nInfo)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }